import "Static/js/drilldown";
import Highcharts from "Static/js/highstock";
import "Static/js/standalone-framework";

function configure() {
  Highcharts.setOptions({
    colors: [
      "#0073b7", // Blue
      "#dd4b39", // Red
      "#00a65a", // Green
      "#f39c12", // Yellow
      "#605ca8", // Purple
      "#00c0ef", // Aqua
      "#ff851b", // Orange
      "#d81b60", // Maroon
      "#39cccc", // Teal
      "#001f3f", // Navy
      "#3d9970", // Olive
      "#f012be", // Fuchsia
      "#01ff70", // Lime
    ],
    global: {
      useUTC: false,
    },
  });
}

function createChart(opts) {
  if (Highcharts.Chart) {
    return new Highcharts.Chart(opts);
  }
}

export default {
  configure,
  createChart,
};
